import FemaleIcon from '@/assets/female.svg?react';
import MaleIcon from '@/assets/male.svg?react';

import { OnbOptionType } from '../../../../types';
import { LayoutDataType } from '../../types';

export const GENDER_OPTIONS: (OnbOptionType<LayoutDataType['gender']> & {
  Icon: React.FC;
  iconPosition: 'left' | 'right';
})[] = [
  {
    id: 'female',
    title: 'AI-WOMAN',
    Icon: FemaleIcon,
    iconPosition: 'left',
  },
  {
    id: 'male',
    title: 'AI-MAN',
    Icon: MaleIcon,
    iconPosition: 'right',
  },
];
